module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "scroll-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.handleScroll($event)
      }
    }
  }, [_c('div', {
    ref: "scrollWrapper",
    staticClass: "scroll-wrapper",
    style: ({
      left: _vm.left + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6210b532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollPane/index.vue
// module id = 1290
// module chunks = 160